import '@babel/polyfill'
//阿里云ARMS性能监控
// import 'utils/aliARMS.js'
import 'font-awesome/css/font-awesome.css';

import Vue from 'vue';
import App from './App';
import router from './../../router';
import iView from './iviewReset';
import components from 'components/global';
import store from './../../store';
import service from './../../service';
import VueAMap from 'vue-amap';
// 定制ivew主题样式
import './../../styles/index.less';
import './../../styles/table.less';
Vue.config.productionTip = false;
Vue.prototype.$service = service;

Vue.use(iView);
Vue.use(components);

//防止button等再得到焦点状态的二次误触
window.addEventListener('keyup', function(e) {
  let event = e || window.event;
  let target = event.target || event.srcElement
  let code = event.keyCode || event.which || event.charCode;
  if (code == 13 && target && target.nodeName === "BUTTON") {
    target.blur()
  }
},true)
window.addEventListener('click', function (e) {
  let event = e || window.event;
  let target = event.target || event.srcElement
  if (target && target.nodeName === "BUTTON") {
    target.blur()
  }
},true)
VueAMap.initAMapApiLoader({
  key: '1001129a414cce091a331de7fc273df1',
  plugin: [
    'Autocomplete',
    'PlaceSearch',
    'Scale',
    'OverView',
    'ToolBar',
    'MapType',
    'PolyEditor',
    'CircleEditor',
    'Geolocation'
  ]
});
Vue.use(VueAMap);

const errHandlerLog = function(errMsg) {
  let errInfo = { time: new Date().getTime(), info: window.location.href + errMsg };
  let errMsgList = store.state.errHandleList;
  let errFlag = false;
  let findFlag = false;
  for (let item of errMsgList) {
    if (item.info == errInfo.info) {
      findFlag = true;
      if (errInfo.time - item.time < 60 * 1000) {
        errFlag = true;
      } else {
        item.time = errInfo.time;
        store.commit('SET_ERR_HANDLE_LIST', errMsgList);
      }
      break;
    }
  }
  if (!findFlag) {
    errMsgList.push(errInfo);
    store.commit('SET_ERR_HANDLE_LIST', errMsgList);
  }
  if (!errFlag) {
    let errData = {
      url: window.location.href,
      error_msg: errMsg,
      user_agent: navigator.userAgent
    };
    service.post('/Web/Upload/jslog', errData);
  }
};
// 一般错误上报
window.onerror = function(msg, url, line, col, error) {
  console.error(error);
  //由于浏览器的同源策略往往无法获取错误的具体信息，需要手动上报。
  window.__bl && __bl.error(error, {
    filename: url,
    lineno: line,
    colno: col
  });
  errHandlerLog(msg);
};

// 组件渲染时出现运行错误上报
Vue.config.errorHandler = function (err, vm, info) {
  console.error(err);
  window.__bl && __bl.error(err, {
    filename: `${window.location.href}, ${vm.$vnode.tag}, ${info}`
  });
  errHandlerLog(err.message);
};
// // google统计
// (function(i, s, o, g, r, a, m) {
//   i['GoogleAnalyticsObject'] = r;
//   (i[r] =
//     i[r] ||
//     function() {
//       (i[r].q = i[r].q || []).push(arguments);
//     }),
//     (i[r].l = 1 * new Date());
//   (a = s.createElement(o)), (m = s.getElementsByTagName(o)[0]);
//   a.async = 1;
//   a.src = g;
//   m.parentNode.insertBefore(a, m);
// })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

// ga('create', 'UA-85778158-1', 'auto');
// ga('send', 'pageview');

// 百度统计
// var _hmt = _hmt || [];
// (function() {
//   var hm = document.createElement('script');
//   hm.src = '//hm.baidu.com/hm.js?407e2bd7b2e251ed84a39976dd041cc6';
//   var s = document.getElementsByTagName('script')[0];
//   s.parentNode.insertBefore(hm, s);
// })();

router.beforeEach((to, from, next) => {
  if(from.fullPath.indexOf('/course/addTeamClass') != -1 && to.fullPath.indexOf('/Web/TeamclassSwim/teamclass_list') == -1 && to.fullPath.indexOf('/Web/TeamclassPrivate/teamclass_list') == -1){
    sessionStorage.setItem('club_id', '')
  }
  if(to.fullPath.indexOf('/index') != -1 && to.name === '概况'){
    router.push({path:'/Web/MemberList/member_list'})
    return false;
  }
  iView.LoadingBar.start();
  next();
  // 第一次加载页面时无法在此处获取store.state.busName 需要在headerTop组件中重新设置
  // document.title = `${store.state.busName ? store.state.busName : 'YUE Sports'}_${to.name}`;
  document.title = `YUE Sports_${to.name}`;
});

router.afterEach(router => {
  iView.LoadingBar.finish();
  // Cannot read property 'nodeName' of null
  if (document.readyState === "complete") {
    let vipMainCon = document.getElementById('vipMainCon');
    if (vipMainCon) {
      vipMainCon.scrollTop = -40;
    }
  }
  // google统计
  // let currentUrl = window.location.origin + '/#' + router.path;
  // ga &&
  //   ga('send', 'pageview', {
  //     page: currentUrl, // 手动设置 path
  //     title: `${store.state.busName ? store.state.busName : 'Y·TIME'}_${router.name}`
  //   });
  // 百度统计
  // _hmt.push(['_trackPageview', router.path]);
});

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
